import React from 'react';
import  SplashScreenView  from '../../Views/AfterAuth/SplashScreenView/SplashScreenView';

const SplashScreen = () => {
    return <SplashScreenView />;
};

export default SplashScreen;
